import Sync from 'Components/Sync'
import { connect } from 'react-redux'

const defaultRequest = {
  syncing: null, // Hasn't started yet
  responseBody: null,
  statusCode: null,
  url: null,
  method: null,
}

const mapStateToProps = state => {
  var hasError = false
  var syncRequests = state.sync.syncingRequestIds.map(id => {
    var request = state.sync.syncingRequests[id] || defaultRequest
    if (request.responseBody) {
      var errorMessage = maybeGetError(request.responseBody)
      if (errorMessage) hasError = true
    }
    return {
      errorMessage,
      syncing: request.syncing,
      statusCode: request.statusCode,
      url: request.url,
      method: request.method,
    }
  })

  return {
    syncing: state.sync.syncing,
    syncRequests,
    hasError,
    errorMessage: state.sync.error && state.sync.error.message,
  }
}

export default connect(mapStateToProps)(Sync)

/**
 * Parses the error in the respose and returns the first error message if there
 * was one.
 * @param {string} response
 * @returns {string|null}
 */
function maybeGetError(response) {
  try {
    response = JSON.parse(response)
  } catch (err) {
    return null
  }
  if (response && response.errors) return response.errors[0].message
}
